// extracted by mini-css-extract-plugin
module.exports = {"spinner-color-blue":"_3xRzC","spinnerColorBlue":"_3xRzC","spinner-color-gray50":"_3X2uM","spinnerColorGray50":"_3X2uM","spinner-color-white":"_2-tRs","spinnerColorWhite":"_2-tRs"};